/** @format */
import {
    Icon,
    IconSize,
    IconVariant,
} from '@mpb-com/feather/components/atoms/icon';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { styles } from './product-details-list-item.styles';
import { ProductDetailsListItemProps } from './types';

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-details-list-item';

export const StyledProductDetailsListItem = styled.li`
    ${styles}
`;

export const ProductDetailsListItem: FunctionComponent<
    ProductDetailsListItemProps
> = ({
    'data-testid': dataTestId = DEFAULT_TEST_ID,
    icon,
    title,
    children,
    ...otherProps
}) => (
    <StyledProductDetailsListItem {...otherProps} data-testid={dataTestId}>
        <Icon
            className="product-details-list-item-icon"
            data-testid={`${dataTestId}__icon`}
            variant={IconVariant.DECORATIVE}
            size={IconSize.S}
        >
            {icon}
        </Icon>
        <div
            className="product-details-list-item-title"
            data-testid={`${dataTestId}__title`}
        >
            {title}
        </div>
        {/* eslint-disable-next-line react/jsx-no-leaked-render -- Legacy code: do not use as an example. */}
        {children && (
            <div
                className="product-details-list-item-content"
                data-testid={`${dataTestId}__content`}
            >
                {children}
            </div>
        )}
    </StyledProductDetailsListItem>
);
